import { getSeason } from '../../utils/time.js';
import { CONFIG } from '../../config/constants.js';

export function ResourceBar({ day, food, wood, stone, metal = 0, knowledge = 0, techPoints = 0, workers }) {
  const aliveWorkers = workers.filter(w => w.status !== 'dead');
  const season = getSeason(day);
  const seasonIcons = { Spring: '🌸', Summer: '☀️', Autumn: '🍂', Winter: '❄️' };

  return (
    <header
      className="bg-amber-900/90 backdrop-blur text-amber-50 px-4 py-3 rounded-xl shadow-lg mb-4"
      role="banner"
      aria-label="Game status"
    >
      <div className="flex flex-wrap justify-between items-center gap-2">
        <div className="font-bold">
          <span className="mr-2">Day {day}</span>
          <span aria-label={`Season: ${season}`}>{seasonIcons[season]} {season}</span>
        </div>
        <div className="flex gap-4 text-lg" role="list" aria-label="Resources">
          <span role="listitem" aria-label={`Food: ${food}`}>🌾 {food}</span>
          <span role="listitem" aria-label={`Wood: ${wood}`}>🪵 {wood}</span>
          <span role="listitem" aria-label={`Stone: ${stone}`}>🪨 {stone}</span>
          <span role="listitem" aria-label={`Metal: ${metal}`}>🔩 {metal}</span>
          <span role="listitem" aria-label={`Knowledge: ${knowledge} out of ${CONFIG.KNOWLEDGE_CAP}`}>📚 {knowledge}/{CONFIG.KNOWLEDGE_CAP}</span>
          <span role="listitem" aria-label={`Tech Points: ${techPoints}`}>⚙️ {techPoints}</span>
          <span role="listitem" aria-label={`Workers: ${aliveWorkers.length}`}>👥 {aliveWorkers.length}</span>
        </div>
      </div>
    </header>
  );
}
